import React from 'react'
import { useState } from 'react'
import css from './ListUser.module.scss'
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { et } from 'date-fns/locale';
import { createUser, getListGroup } from '../../../Services/Admin/ListAdminServices';
import { set } from 'date-fns';
const CreateUserEnergyPage = () => {
    const {control, register, handleSubmit, setValue, watch, formState: { errors }, reset} = useForm();
    const navigate = useNavigate();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [buttonClicked, setButtonClicked] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    const [StatusCheckPLTS, setCheckPLTS] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isErrorMessage, setIsErrorMessage] = useState(false);
    
    const showModal = () => setIsSuccess(true);
    const hideModal = () => {
        setIsSuccess(false)
        reset()
    };

    function onCreate(data) {
        // alert('create')
        if(buttonClicked == 'save'){
            createUser(data).then((result) => {    
                setIsSuccess(true)
            }).catch(({ response }) => {
                setIsError(true)
                setIsErrorMessage(response.data.message)
            });
        }
    }
    const FindGroup = (e) => {
        getListGroup(e.target.value).then((result) => {    
            console.log(result.data)
            setValue('group_id', e.target.value)
            setValue('huawei_username', result.data.data.name)
            setValue('huawei_password', result.data.data.password)
            setValue('current_user', result.data.total)
        }).catch(({ response }) => {
            console.log(response)
        });
        // e.target.value
        setCheckPLTS(true)
    }

  return (
    <div className='wrap_admin'>
        {isSuccess && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been created. </p>
                </div> 
            </div>
        }
        
        {isError && 
            <div className={css.popup_wrap} onClick={()=> setIsError(false)}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={()=> setIsError(false)}></i>
                    <img src="/monitoring/assets/error.png" />
                    <b>Error!</b>
                    <p>{isErrorMessage} </p>
                </div> 
            </div>
        }
        <div className='row vh-100'>
            <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                    <form className={`${css.form}`} onSubmit={handleSubmit(onCreate)}>
                        <div className='row'>
                            <div className='col-md-6'>
                                <label>Username</label>
                                <input type='text' placeholder='Add Username' 
                                    {...register("username", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.username && <p style={{color:'red'}}>This field is required</p>}

                                <label>Name</label>
                                <input type='text' placeholder='Add Name' 
                                    {...register("name", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.name && <p style={{color:'red'}}>This field is required</p>}

                                
                                <label>Email</label>
                                <input type='text' placeholder='Add Email'
                                    {...register("email", {
                                        required: "Email is required",
                                        pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                        message: "Invalid email address"
                                        }
                                    })} 
                                />
                                {errors.email && <p style={{color:'red'}}>{errors.email.message}</p>}


                                
                                <label>Password</label>
                                <input type='password' placeholder='Add Password' 
                                
                                    {...register("password", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.password && <p style={{color:'red'}}>This field is required</p>}


                                <label>Phone Number</label>
                                <input type='text' placeholder='Add Phone number' 
                                    {...register("phone", { 
                                        required: "This field is required"
                                    })}
                                />
                                {errors.phone && <p style={{color:'red'}}>This field is required</p>}

                                
                            </div>
                            <div className='col-md-6'>
                                <label>Group</label>
                                <select onChange={FindGroup}>
                                    <option value={''}>Choose Group</option>
                                    <option value={1}>Group 1</option>
                                    <option value={2}>Group 2</option>
                                    <option value={3}>Group 3</option>
                                    <option value={4}>Group 4</option>
                                </select>
                                
                                <label>username</label>
                                <input type='text' placeholder='Add Email' readOnly style={{background:'#F5F5F5'}}
                                    {...register("huawei_username", { required: true })}   
                                />
                                
                                <label>Password</label>
                                <input type='text' placeholder='Add Password' readOnly  style={{background:'#F5F5F5'}}   
                                    {...register("huawei_password", { required: true })}     
                                />

                                <label>Current User</label>
                                <input type='text' placeholder='Confirm user' readOnly  style={{background:'#F5F5F5'}}
                                    {...register("current_user", { required: true })}   
                                />
                                
                                <label>Station</label>
                                <input type='text' placeholder='Add Station'
                                    {...register("station_code", { required: true })}   
                                />
                                {errors.station_code && <p style={{color:'red'}}>This field is required</p>}
                                
                            </div>
                        </div>
                        

                        <div className='row' style={{marginTop:40, marginLeft:-15}}>
                            <div className='col-md-8'>
                                {/* <button className='admin-button delete' onClick={() => setButtonClicked('delete')}>Delete</button> */}
                            </div>
                            <div className='col-md-4' style={{float:'right'}}>
                                <button className='admin-button cancel' onClick={() => navigate(-1)} style={{marginRight:10}}>Cancel</button>
                                <button className='admin-button save' onClick={() => setButtonClicked('save')} disabled={StatusCheckPLTS == false ? true : false} >Save</button>  
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default CreateUserEnergyPage